module.exports = __webpack_public_path__ + "img/sou-nick.f3a9f3e4.png";